import { Twitter, Linkedin, Github, Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const SOCIALS = [Twitter, Linkedin, Github, Instagram];

const NAV = [
  ["What We Do", "/what-we-do"],
  ["Pricing", "/pricing"],
  ["Portfolio", "/portfolio"],
  ["About", "/about"],
  ["Contact", "/contact"],
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="px-5 md:px-10 pb-10 pt-6">
      <div className="max-w-[1440px] mx-auto">
        <div className="glass-panel px-6 py-10 md:px-12 md:py-12">
          <div className="grid md:grid-cols-3 gap-10">
            <div>
              <Link to="/"><Logo size={36} wordmarkClass="text-lg" /></Link>
              <p className="mt-4 text-sm text-[#AEBFD8] max-w-xs leading-relaxed">
                Modern websites. Human-focused service.
              </p>
              <a href="mailto:team@harmanaisolutions.com" data-testid="footer-email"
                className="mt-4 inline-flex items-center gap-2 text-sm text-[#AEBFD8] hover:text-[#39D5FF] transition">
                <Mail size={16} /> team@harmanaisolutions.com
              </a>
              <div className="flex gap-3 mt-5">
                {SOCIALS.map((Icon, i) => (
                  <a key={i} href="/" aria-label="Social link" data-testid={`footer-social-${i}`}
                    className="grid place-items-center w-10 h-10 rounded-xl bg-[rgba(14,43,82,0.48)] border border-[rgba(67,157,255,0.35)] text-[#AEBFD8] hover:text-[#39D5FF] hover:border-[#39D5FF] transition min-h-[44px] min-w-[44px]">
                    <Icon size={18} />
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-[#F7FAFF] mb-4">Navigate</h4>
              <ul className="space-y-2.5 text-sm">
                {NAV.map(([l, h]) => (
                  <li key={h}><Link to={h} className="text-[#AEBFD8] hover:text-[#39D5FF] transition">{l}</Link></li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-[#F7FAFF] mb-4">Company</h4>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/privacy-policy" className="text-[#AEBFD8] hover:text-[#39D5FF] transition" data-testid="footer-privacy">Privacy Policy</Link></li>
                <li><Link to="/terms-and-conditions" className="text-[#AEBFD8] hover:text-[#39D5FF] transition" data-testid="footer-terms">Terms and Conditions</Link></li>
                <li><Link to="/cookie-policy" className="text-[#AEBFD8] hover:text-[#39D5FF] transition" data-testid="footer-cookies">Cookie Policy</Link></li>
                <li><Link to="/contact" className="text-[#AEBFD8] hover:text-[#39D5FF] transition" data-testid="footer-contact">Contact</Link></li>
                <li><a href="https://harmanaisolutions.com" className="text-[#AEBFD8] hover:text-[#39D5FF] transition">harmanaisolutions.com</a></li>
              </ul>
            </div>
          </div>

          <div className="glow-divider my-8" />
          <p className="text-center text-xs text-[#7F92AE]">© {year} Harman AI Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
